var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel t1 text-center p-2"},[_c('h4',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm._f("translate")("Gesamtsumme"))+": "),_c('br'),_c('span',[_c('strong',[_vm._v(_vm._s(_vm._f("currency")(_vm.total,_vm.cSymb)))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }